import React from 'react';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useHistory } from "react-router-dom";
import { useRef } from 'react';
import '../../css/common.css';
import '../../css/style.css';
import '../../css/main_style.css';
import '../../css/maindash.css';
import '../../css/table.css';
import * as Common from '@/utils/Common';

function Breadcrumb({ children, onInfoMsg, newTabUnused, onInfoManual }) {
    const history = useHistory();
    const bigi = Common.getToken("bigi");
    const popupRef = useRef(null);
    const helpRef = useRef(null);

    const onClickInfo = (e) => {
        if (helpRef.current) {
            helpRef.current.innerHTML = onInfoMsg;
        }
        if (popupRef.current) {
            if (popupRef.current.style.display === 'block') {
                popupRef.current.style.display = 'none';
            } else {
                popupRef.current.style.display = 'block';
            }
        }
    };

    const onClickManual = (e) => {
        const pagePath = window.location.pathname.split('/')[2];

        const url = "https://rapdos.co.kr/help/" + pagePath + ".html";
        window.open(url, 'RapdosManual', '_blank');
    };

    const onClickNewTab = (e) => { // 브라우저 새탭에서 보기 기능

        let url = window.location.href;
        window.open(url, '_blank');
    };

    return (
        <>
            <div className="position_list" style={{ display: "flex", alignItems: "center", minHeight: "30px" }}>
                <span style={{ fontFamily: "'PretendardMedium', 'NanumGothic', sans-serif", cursor: "default", display: "flex", alignItems: "center", width: "100%" }}>
                    {/* 1. 경로 */}
                    {history.location.pathname === "/" ? (
                        <span title="경로" style={{ fontFamily: "'PretendardMedium', 'NanumGothic', sans-serif", fontSize: "17px", lineHeight: "1" }}>
                            {children}
                        </span>
                    ) : (
                        <span title="경로" style={{ fontFamily: "'PretendardMedium', 'NanumGothic', sans-serif", fontSize: "13.1px", lineHeight: "1" }}>
                            Position : {children}
                        </span>
                    )}

                    {/* 2. 새창 버튼 */}
                    {!newTabUnused && (
                        <span title="[New Browser] Open" onClick={onClickNewTab} style={{ marginLeft: "5px" }}>
                            <div style={{
                                background: "#ed5d3b", fontSize: "13.1px", fontFamily: "'PretendardMedium'", cursor: "pointer", color: "#ffffff",
                                borderRadius: "92px", width: "50px", height: "20px", display: "flex", alignItems: "center", justifyContent: "center"
                            }}>
                                새창
                            </div>
                        </span>
                    )}

                    {/* 3. 매뉴얼 버튼 */}
                    {onInfoManual !== false && (
                        <span style={{ marginLeft: "5px", display: "flex", alignItems: "center" }}>
                            <img
                                className="btn_manual"
                                src="/images/button/btn_manual.png"
                                alt="Manual Botton"
                                title="New Browser [ Manual ] Open"
                                onClick={onClickManual}
                                style={{ cursor: "pointer" }}
                            />
                        </span>
                    )}

                    {/* 4. 도움말 버튼 */}
                    {onInfoMsg && (
                        <span style={{ marginLeft: "5px", marginRight: "5px", display: "flex", alignItems: "center" }}>
                            <img
                                className="btn_help"
                                src="/images/button/btn_question.png"
                                alt="Question Botton"
                                title="[show Tip] Open"
                                onClick={onClickInfo}
                                style={{ cursor: "pointer" }}
                            />
                        </span>
                    )}
                </span>
            </div>
            <div ref={popupRef} id="popup_layer">
                <p ref={helpRef} className="p_help"></p>
            </div>

        </>
    );
}

export default Breadcrumb;